// Prevent Bootstrap dropdowns from closing when interacting with elements inside the menu.
// Uses capture-phase listener so it runs before Bootstrap's document handler.

(function () {
  function isInKeepOpenMenu(target) {
    return !!(target && target.closest && target.closest('.dropdown-menu[data-keepopen="true"]'));
  }

  document.addEventListener(
    'click',
    function (e) {
      if (isInKeepOpenMenu(e.target)) {
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'mousedown',
    function (e) {
      if (isInKeepOpenMenu(e.target)) {
        e.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function (e) {
      if (isInKeepOpenMenu(e.target)) {
        e.stopPropagation();
      }
    },
    true
  );
})();
